import { createInvokeEpic } from '../../../signalr/createInvokeEpic'

import { fetchVenuesDefinition } from './definition'

export default createInvokeEpic('venue.fetch', fetchVenuesDefinition)
